// extracted by mini-css-extract-plugin
export default {"image":"Card_image__Vd96d","section":"Card_section__m-5O+","container":"Card_container__XuAwz"};